import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import PodcastEpisodeCardSkeleton from '@/app/components/listing/skeleton-loaders/PodcastEpisodeCardSkeleton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PodcastEpisodesBlockSkeleton',
  setup(__props) {

const numberOfCardsToRender = 3

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListingBlockLayout, { title: "Podcast Episodes" }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(numberOfCardsToRender, (i) => {
        return _createVNode(PodcastEpisodeCardSkeleton, { key: i })
      }), 64))
    ]),
    _: 1
  }))
}
}

})